import {useState, useEffect, useCallback, Fragment} from "react";
import {startOfMonth,endOfMonth,getMonth,setMonth,getYear,setYear,endOfYesterday} from "date-fns";

import {MenuItem} from "@mui/material";

import { DialogCustom } from "../../../components/ModalCustom";
import { DatePickerCustom, RadioGroupCustom, SelectCustom } from "../../../components/InputCustom";
import { ButtonConfirmCustom } from "../../../components/ButtonCustom";
import {PERIODS,AVAILABLE_PERIODS,AVAILABLE_FREQUENCIES,AVAILABLE_MONTHS,
    AviableYears,AVAILABLE_FREQUENCIES_CUSTOM} from "./settings";

export default function PeriodPicker(props) {
  const {showPeriodPicker,onClose,onConfirm,reportFromDate,
    reportToDate,selectedPeriod,selectedFrequency} = props

  const [from, setFrom] = useState(reportFromDate);
  const [to, setTo] = useState(reportToDate);
  const [period, setPeriod] = useState(selectedPeriod);
  const [freq, setFreq] = useState(selectedFrequency);

  useEffect(() => {
    setFrom(reportFromDate);
    setTo(reportToDate);
    setPeriod(selectedPeriod);
    setFreq(selectedFrequency);
  },[reportFromDate, reportToDate, selectedFrequency, selectedPeriod]);

  useEffect(() => {
    //reset values when modal is closed
    if (!showPeriodPicker) {
      setFrom(reportFromDate);
      setTo(reportToDate);
      setPeriod(selectedPeriod);
      setFreq(selectedFrequency);
    }
  }, [reportFromDate, reportToDate, selectedFrequency, selectedPeriod, showPeriodPicker]);

  ///FUNZIONE DI AGGIORNAMENTO DELLE DATE
  const updateDates = (newFrom, newTo, newFreq = freq) => {
    setFrom(newFrom);
    setTo(newTo);
    setFreq(newFreq);
  };

  const onPeriodChange = useCallback((event) => {
    const newPeriod = event.target.value;
    setPeriod(newPeriod);
    if (newPeriod === PERIODS.LAST_MONTH) {  
      const fromStartOfMonth = (startOfMonth(new Date()) > endOfYesterday()) ? 
        startOfMonth(endOfYesterday()) : 
        startOfMonth(new Date());
      updateDates(fromStartOfMonth, endOfYesterday(), "24h");
    }
    // eslint-disable-next-line
  },[],);

  const onFrequencyChange = useCallback((event) => setFreq(event.target.value),[]);

  const onMonthChange = useCallback((event) => {
    const month = event.target.value;
    const newDate = setMonth(to, month);
    updateDates(startOfMonth(newDate), endOfMonth(newDate));
    // eslint-disable-next-line
  },[to]);

  const onYearChange = useCallback((event) => {
    const year = event.target.value;
    const newDate = setYear(to, year);
    updateDates(startOfMonth(newDate), newDate);
    // eslint-disable-next-line
  },[to]);

  const onConfirmChanges = useCallback(() => {
    onConfirm(from,to,period,freq);
  },[freq, from, onConfirm, period, to],);

  const configSelect = {
    Component:SelectCustom,
    configMonth:{
      idBox:"monthPicker",
      labelId:"month-label",
      label:"Mese",
      id:"month",
      value:getMonth(to),
      onChange:onMonthChange,
      children: AVAILABLE_MONTHS.map((month, index) => {
        const disabled = new Date(getYear(to), index) > endOfYesterday();
        return <MenuItem key={month} value={index} disabled={disabled}>{month}</MenuItem>
      })
    },
    configYear:{
      idBox:"yearPicker",
      labelId:"year-label",
      label:"Mese",
      id:"year",
      value:getYear(to),
      onChange:onYearChange,
      children: AviableYears().map(year => (
        <MenuItem key={year} value={year}>{year}</MenuItem>))
    },
    configFrequency:{
      className:"frequency-input",
      labelId:"frequency-label",
      label:"Frequenza",
      id:"frequency",
      value:freq,
      onChange:onFrequencyChange,
      children: AVAILABLE_FREQUENCIES.map(({id, label}) => (
        <MenuItem key={id} value={id}>{label}</MenuItem>
      ))
    },
  }

  const configDatePicker = {
    Component:DatePickerCustom,
    configStartDate:{
      idBox:"startDatePicker",
      id:"startDate",
      label:"Data inizio",
      format:"dd/MM/yyyy",
      value:from,
      onChange:useCallback((value) => setFrom(value),[]),
      minDate:new Date("2019-01-01"),
      maxDate:to
    },
    configEndDate:{
      idBox:"endDatePicker",
      id:"endDate",
      label:"Data fine",
      format:"dd/MM/yyyy",
      value:to,
      onChange:useCallback((value) => setTo(value),[]),
      minDate:new Date("2019-01-01"),
      maxDate:endOfYesterday
    },
  }

  const configFrequencyCustom ={
    Component:SelectCustom,
    configFrequency:{
      className:"frequency-input",
      labelId:"frequency-label",
      label:"Frequenza",
      id:"frequency",
      value:freq,
      onChange:onFrequencyChange,
      children: AVAILABLE_FREQUENCIES_CUSTOM.map(({id, label}) => (
        <MenuItem key={id} value={id}>{label}</MenuItem>
      ))
    },
  }

  const renderMensile = () => {
    return (
      <Fragment>
        <configSelect.Component {...configSelect.configMonth}/>
        <configSelect.Component {...configSelect.configYear}/>
        <configSelect.Component {...configSelect.configFrequency} />
      </Fragment>
    )
  }

  const renderCustomized = () => {
    return (
      <Fragment>
        <configDatePicker.Component {...configDatePicker.configStartDate}/>
        <configDatePicker.Component {...configDatePicker.configEndDate}/>
        <configFrequencyCustom.Component {...configFrequencyCustom.configFrequency} />
      </Fragment>
    )
  }

  const renderBody = () => {
    return (
      <Fragment>
        <RadioGroupCustom period={period} onPeriodChange={onPeriodChange} aviablePeriods={AVAILABLE_PERIODS}/>
        {period === PERIODS.LAST_MONTH && <configSelect.Component {...configSelect.configFrequency} />}
        {period === PERIODS.MONTH && renderMensile()}
        {period === PERIODS.CUSTOM && renderCustomized()}
      </Fragment>
    )
  }
  const configButton = {
    Component:ButtonConfirmCustom,
    func:{
      onClickCancel:onClose,
      onClickConfirm:onConfirmChanges,
    }
  }
  return (
    <DialogCustom 
        renderButton={<configButton.Component {...configButton.func}/>} 
        renderBody={renderBody()}
        open={showPeriodPicker}
        onClose={onClose}
        title="Periodo"
    />
  );
}
